import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faLongArrowAltRight from '@fortawesome/fontawesome-free-solid/faLongArrowAltRight';
import './HomeProduct.css';
import Config from '../config/config';
import { isMobile } from '../lib/util';

const HomeProduct = (props) => {
  const { homeProductData } = props;
  const productParams = {
    slidesPerView: isMobile() ? 1 : 3,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  return (
    <Swiper {...productParams}>
      {homeProductData.map((elem, idx) => {
        const { primaryImage, secondaryImage } = elem;
        const primaryImageUrl = ( primaryImage && primaryImage[0] ) ? primaryImage[0].url : '';
        const secondaryImageUrl = ( secondaryImage && secondaryImage[0] ) ? secondaryImage[0].url : '';

        if (elem.split) {
          return (
            <div className="split" key={`product${idx}`}>
              <div className="division slide-product-wrapper">
                <div className="slide-product">
                  <figure className="image is-2by1">
                    <div 
                      style={{backgroundImage:`url(${Config.apiUrl}${primaryImageUrl})`}}
                      className="slide-product-image"
                    />
                  </figure>
                  <Link className="product-link" to={elem.primaryLink}>
                    <span className="product-link__text">{elem.primaryName}</span>
                    <span className="icon product-link-icon">
                      <FontAwesomeIcon className="icon" icon={faLongArrowAltRight} />
                    </span>
                  </Link>
                </div>
              </div>
              <div className="division slide-product-wrapper">
                <div className="slide-product">
                  <figure className="image is-2by1">
                    <div 
                      style={{backgroundImage:`url(${Config.apiUrl}${secondaryImageUrl})`}}
                      className="slide-product-image"
                    />
                  </figure>
                  <Link className="product-link" to={elem.secondaryLink}>
                    <span className="product-link__text">{elem.secondaryName}</span>
                    <span className="icon product-link-icon">
                      <FontAwesomeIcon className="icon" icon={faLongArrowAltRight} />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          );
        }
        return (
          <div className="slide-product-wrapper" key={`product${idx}`}>
            <div className="slide-product">
              <figure className="image is-square">
                <div 
                  style={{backgroundImage:`url(${Config.apiUrl}${primaryImageUrl})`}}
                  className="slide-product-image"
                />
              </figure>
              <Link className="product-link" to={elem.primaryLink}>
                <span className="product-link__text">{elem.primaryName}</span>
                <span className="icon product-link-icon">
                  <FontAwesomeIcon className="icon" icon={faLongArrowAltRight} />
                </span>
              </Link>
            </div>
          </div>
        );
      })}
    </Swiper>
  );
};

HomeProduct.propTypes = {
  homeProductData: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default HomeProduct;



// WEBPACK FOOTER //
// ./src/components/HomeProduct.js